import { faClose } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { lazy, Suspense } from 'react';

import CategoryProductList from 'Component/CategoryProductList';
import Html from 'Component/Html';
import YBCategoryExtraContent from 'Component/YBCategoryExtraContent';
import YBCategoryPerfumes from 'Component/YBCategoryPerfumes';
import { GRID_LAYOUT } from 'Route/CategoryPage/CategoryPage.config';
import {
    CategoryFilterOverlay,
    CategoryPage as SourceCategoryPage
} from 'SourceRoute/CategoryPage/CategoryPage.component';
import { isCrawler, isSSR } from 'Util/Browser';
import isMobile, { isApp } from 'Util/Mobile/isMobile';

import './CategoryPage.override.style';

export const CategoryFilterAux = lazy(() => import(
    /* webpackMode: "lazy", webpackChunkName: "overlays-category-aux" */ 'Component/CategoryFilterAux'
));

export {
    CategoryFilterOverlay
};

/** @namespace Elganso/Route/CategoryPage/Component */
export class CategoryPageComponent extends SourceCategoryPage {
    componentDidUpdate(prevProps) {
        const { isCurrentCategoryLoaded: prevIsCurrentCategoryLoaded } = prevProps;
        const { isCurrentCategoryLoaded } = this.props;

        if (isCurrentCategoryLoaded && prevIsCurrentCategoryLoaded !== isCurrentCategoryLoaded) {
            // Ponemos la bandera del prerender a true
            window.prerenderReady = true;
        }
    }

    renderFilterButtonDesktop() {
        const {
            isContentFiltered,
            totalPages,
            category: { is_anchor },
            isSearchPage,
            isCurrentCategoryLoaded,
            isMatchingInfoFilter,
            appliedFiltersCount,
            topNavigationState: { name } = {},
            onFilterButtonClick
        } = this.props;

        if (!isMatchingInfoFilter) {
            return this.renderFilterButtonPlaceholder();
        }

        if ((!isContentFiltered && totalPages === 0) || (!is_anchor && !isSearchPage) || !isCurrentCategoryLoaded) {
            return null;
        }

        let filterDesc = __('Filters');
        if (appliedFiltersCount > 0) {
            filterDesc = `${ filterDesc }(${ appliedFiltersCount })`;
        }

        return (
            <button
              block="CategoryPage"
              elem="Filter"
              mods={ { isContentFiltered } }
              mix={ { block: 'CategoryPage', elem: 'FilterDesktop' } }
              onClick={ onFilterButtonClick }
            >
                { name === 'filter' ? <FontAwesomeIcon icon={ faClose } /> : filterDesc }
            </button>
        );
    }

    renderFilterButton() {
        const {
            isContentFiltered,
            totalPages,
            category: { is_anchor },
            isSearchPage,
            isCurrentCategoryLoaded,
            isMatchingInfoFilter,
            topNavigationState: { name } = {},
            onFilterButtonClick
        } = this.props;

        if (!isMatchingInfoFilter) {
            return this.renderFilterButtonPlaceholder();
        }

        if ((!isContentFiltered && totalPages === 0) || (!is_anchor && !isSearchPage) || !isCurrentCategoryLoaded) {
            return null;
        }

        if (!isMobile.any()) {
            return this.renderFilterButtonDesktop();
        }

        if (isContentFiltered) {
            return (
                <button
                  block="CategoryPage"
                  elem="Filter"
                  onClick={ onFilterButtonClick }
                >
                    { name === 'filter'
                        ? <FontAwesomeIcon icon={ faClose } />
                        : <div block="IconoFiltros" mods={ { isContentFiltered } } /> }
                </button>
            );
        }

        return (
            <button
              block="CategoryPage"
              elem="Filter"
              onClick={ onFilterButtonClick }
            >
                { name === 'filter'
                    ? <FontAwesomeIcon icon={ faClose } />
                    : <div block="IconoFiltros" /> }
            </button>
        );
    }

    renderCmsBlock() {
        const { category: { cms_block }, isCurrentCategoryLoaded } = this.props;

        // Con isCurrentCategoryLoaded evitamos que se vea el CMS de la categoría actual en la carga al irte a otra categoría
        if (!cms_block || !this.displayCmsBlock() || !isCurrentCategoryLoaded) {
            return null;
        }

        const { content, disabled } = cms_block;

        if (disabled) {
            return null;
        }

        const contentHTML = content.replace(/&lt;/g, '<').replace(/&gt;/g, '>');

        return (
            <div
              block="CategoryPage"
              elem="CMS"
            >
                <Html content={ contentHTML } />
            </div>
        );
    }

    renderMiscellaneous() {
        return (
            <aside block="CategoryPage" elem="Miscellaneous">
                { this.renderItemsCount() }
                <div
                  block="CategoryPage"
                  elem="MiscellaneousLayoutWrapper"
                >
                  <div
                    block="CategoryPage"
                    elem="LayoutWrapper"
                    mods={ { isPrerendered: isSSR() || isCrawler() } }
                  >
                      { this.renderSlider() }
                      { this.renderFilterButton() }
                  </div>
                </div>
            </aside>
        );
    }

    renderSlider() {
        const { min, max } = this.props.getRangoFilas();
        const { updateValue, valueColumn } = this.props;

        return (
            <div
              className="slider-select-column"
            >
                <input
                  block="RangeSlider"
                  elem="input"
                  type="range"
                  min={ min }
                  max={ max }
                  value={ valueColumn }
                  step={ 1 }
                  onChange={ updateValue }
                />
            </div>
        );
    }

    renderFilterAux(categoryFilter) {
        const {
            selectedFilters,
            isMatchingInfoFilter,
            isSearchPage,
            category: {
                is_anchor
            }
        } = this.props;

        if (!is_anchor && !isSearchPage) {
            return null;
        }

        if (!categoryFilter || !Object.keys(categoryFilter).length) {
            return null;
        }

        return (
            <CategoryFilterAux
              availableFilters={ categoryFilter }
              customFiltersValues={ selectedFilters }
              isMatchingInfoFilter={ isMatchingInfoFilter }
              isCategoryAnchor={ !!is_anchor }
              isSearchPage={ isSearchPage }
              renderPlaceholder={ this.renderPlaceholder }
            />
        );
    }

    renderFilterPlaceholder() {
        return null;
    }

    renderFilterButtonPlaceholder() {
        return null;
    }

    renderFilterOverlay() {
        const {
            filters,
            selectedFilters,
            isMatchingInfoFilter,
            isSearchPage,
            category: {
                is_anchor
            },
            isMobile,
            onFilterButtonClick
        } = this.props;

        if (!this.displayProducts()) {
            return null;
        }

        const categoryFilter = {};
        const resto = {};

        if (filters) {
            Object.entries(filters).forEach(([item, _value]) => {
                if (item === 'category_id') {
                    categoryFilter[item] = filters[item];
                } else if (item === 'category_uid') {
                    const cats = filters[item];
                    cats.attribute_code = 'category_id';
                    categoryFilter[item] = cats;
                } else {
                    resto[item] = filters[item];
                }
            });
        }

        return (
            <Suspense fallback={ this.renderFilterPlaceholder() }>
                { this.renderFilterAux(categoryFilter) }
                <CategoryFilterOverlay
                  availableFilters={ resto }
                  customFiltersValues={ selectedFilters }
                  isMatchingInfoFilter={ isMatchingInfoFilter }
                  isCategoryAnchor={ !!is_anchor }
                  isSearchPage={ isSearchPage }
                  renderPlaceholder={ this.renderPlaceholder }
                  isMobile={ isMobile }
                  onFilterButtonClick={ onFilterButtonClick }
                />
            </Suspense>
        );
    }

    renderCategoryProductList() {
        const {
            filter,
            search,
            selectedSort,
            selectedFilters,
            isMatchingListFilter,
            isCurrentCategoryLoaded,
            isMatchingInfoFilter,
            valueColumn
        } = this.props;

        const { activeLayoutType } = this.state;

        if (!this.displayProducts()) {
            return null;
        }

        // Fuerzo ordenación por posición
        const sortedBy = selectedSort;

        if (sortedBy.sortKey === 'name') {
            sortedBy.sortKey = 'position';
        }

        return (
            <div
              block="CategoryPage"
              elem="ProductListWrapper"
              mods={ { isPrerendered: isSSR() || isCrawler() } }
            >
                { this.renderItemsCount(true) }
                <CategoryProductList
                  filter={ filter }
                  search={ search }
                  sort={ sortedBy }
                  selectedFilters={ selectedFilters }
                  isCurrentCategoryLoaded={ isCurrentCategoryLoaded }
                  isMatchingListFilter={ isMatchingListFilter }
                  isMatchingInfoFilter={ isMatchingInfoFilter }
                  layout={ activeLayoutType || GRID_LAYOUT }
                  valueColumn={ valueColumn }
                />
            </div>
        );
    }

    renderCategoryExtraContent() {
        const {
            category,
            isCurrentCategoryLoaded
        } = this.props;

        return (
            <YBCategoryExtraContent
              category={ category }
              isCurrentCategoryLoaded={ isCurrentCategoryLoaded }
            />
        );
    }

    renderPerfumesBanner() {
        const { filter, getMediaByID } = this.props;
        let bannerUrl = '';

        if (filter?.customFilters?.category_id) {
            bannerUrl = getMediaByID(parseInt(filter.customFilters.category_id[0], 10));

            if (bannerUrl.length && bannerUrl[0].url_banner) {
                return (
                    <div block="YBCategoryPerfumes" elem="Banner">
                        <img src={ bannerUrl[0].url_banner } alt="banner_perfumes" />
                    </div>
                );
            }
        }

        return null;
    }

    renderPerfumesVideo() {
        const { filter, getMediaByID } = this.props;
        let media = '';

        if (filter?.customFilters?.category_id) {
            media = getMediaByID(parseInt(filter.customFilters.category_id[0], 10));
            if (media.length && media[0].url_video) {
                return (
                    <div block="YBCategoryPerfumes" elem="Banner">
                        { /* eslint-disable-next-line jsx-a11y/media-has-caption */ }
                        <video autoPlay loop block="video_perfumes" id={ `video_perfumes_${ media[0].name }` } playsInline>
                            <source src={ media[0].url_video } type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                    </div>
                );
            }
        }

        return null;
    }

    renderPerfumesDesign() {
        const {
            category: { children }, isContentFiltered, location, history, getMedia, getMediaByID
        } = this.props;

        if (isContentFiltered) {
            return (
                <>
                    { this.renderFilterBlock() }
                    { this.renderPerfumesBanner() }
                    { this.renderCategoryProductList() }
                    { this.renderPerfumesVideo() }
                </>
            );
        }

        return (
            <YBCategoryPerfumes
              getMedia={ getMedia }
              getMediaByID={ getMediaByID }
              // eslint-disable-next-line react/no-children-prop
              children={ children }
              location={ location }
              history={ history }
            />
        );
    }

    renderPerfumesDesignGame() {
        const url = `https://${ window.location.host }/perfumes/index.php`;
        const style = {
            width: '100%',
            height: '100vh'
        };
        const css = `
            .Header-Wrapper, .Footer{ display: none;}
            .CategoryPage-Wrapper{ padding-top: 0}
        `;

        return (
            <div>
                <style>{ css }</style>
                <object type="text/html" data={ url } style={ style } aria-label="game" />
            </div>
        );
    }

    renderCustomCategoryDesign() {
        const { category: { customizedAttributes } } = this.props;

        if (customizedAttributes && customizedAttributes.customCategoryDesign === 'perfumes') {
            return (
                <>
                   { this.renderPerfumesDesign() }
                </>
            );
        }

        if (customizedAttributes && customizedAttributes.customCategoryDesign === 'perfumes_like_father_like_soon') {
            return (
                <>
                   { this.renderPerfumesDesignGame() }
                </>
            );
        }

        return (
            <>
                { this.renderCategoryContent() }
            </>
        );
    }

    renderFilterBlock() {
        if (isMobile.any()) {
            return (
                <div block="CategoryPage" elem="Filters" className={ isApp() ? 'isApp' : '' }>
                    { this.renderFilterOverlay() }
                    { this.renderMiscellaneous() }
                    <div block="CategoryPage" elem="filterOverlay" />
                </div>
            );
        }

        return (
            <div block="CategoryPage" elem="Filters">
                { this.renderMiscellaneous() }
                { this.renderFilterOverlay() }
                <div block="CategoryPage" elem="filterOverlay" />
            </div>
        );
    }

    renderCategoryContent() {
        return (
            <>
                { this.renderFilterBlock() }
                { this.renderCategoryDetails() }
                { this.renderCmsBlock() }
                { this.renderCategoryProductList() }
                { this.renderCategoryExtraContent() }
            </>
        );
    }

    renderContent() {
        const { category: { customizedAttributes }, search } = this.props;

        if (!search && customizedAttributes !== undefined) {
            if (customizedAttributes.customCategoryDesign) {
                return (
                    <>
                        { this.renderCustomCategoryDesign() }
                    </>
                );
            }
        }

        return (
            <>
                { this.renderCategoryContent() }
            </>
        );
    }
}

export default CategoryPageComponent;
